import { DatePicker } from "antd";
import locale from "antd/locale/fr_FR";
import classnames from "classnames";
import Label from "../../Label";

const { RangePicker } = DatePicker;

const Range = ({
  label,
  errors,
  touched,
  icon,
  required,
  direction,
  ...rest
}) => {
  return (
    <div
      className={classnames(
        "acoris__datepicker",
        { "acoris__datepicker--error": touched && errors },
        { "acoris__datepicker--valid": touched && !errors },
        direction,
      )}
    >
      <Label label={label} icon={icon} required={required} />
      <div className="acoris__datepicker--field">
        <RangePicker
          locale={locale}
          className={classnames({ "disabled--input": rest.disabled })}
          {...rest}
        />
        {touched && errors && <p className="input--errors">{errors}</p>}
      </div>
    </div>
  );
};

export default Range;
